<h2>Schedule</h2>
<form (ngSubmit)="saveAndSendFahrplan()" #scheduleForm="ngForm">
  <label for="scheduleInput">Schedule JSON:</label><br>
  <textarea id="scheduleInput"
    [value]="formattedScheduleInput"
    (input)="onScheduleInput($event)"
    name="scheduleInput"
  rows="10" cols="80"></textarea><br>
  <button type="button" (click)="saveAndSendFahrplan()" [disabled]="loading">Save and send Fahrplan</button>
</form>
@if (loading) {
  <div>Submitting...</div>
}
@if (response) {
  <div>
    <h3>Response</h3>
    <pre>{{ response | json }}</pre>
  </div>
}
@if (error) {
  <div style="color: red;">
    <h3>Error</h3>
    <pre>{{ error }}</pre>
  </div>
}

